import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimeline, faTableColumns, faDashboard,
  faAddressBook,
  faUsers, faFile
} from "@fortawesome/free-solid-svg-icons";

export const pageRoutes = {
  guest: [
    {
      id: 1,
      title: "Profile",
      icon: <FontAwesomeIcon icon={faTableColumns} />,
      link: "/candidate/profile",
    },
  ],
  candidate: [
    {
      id: 1,
      title: "Dashboard",
      icon: <FontAwesomeIcon className="text-2xl" icon={faDashboard} />,
      link: "/candidate/dashboard",
      slug: "dashboard",
    },
    {
      id: 6,
      title: "Self Review",
      icon: <FontAwesomeIcon className="text-2xl" icon={faTimeline} />,
      link: "/candidate/self-review",
      slug: "my-review",
    },
    {
      id: 4,
      title: "Evaluations",
      icon: <FontAwesomeIcon className="text-2xl" icon={faUsers} />,
      link: "/candidate/my-review",
      slug: "my-review",
    },
    {
      id: 7,
      title: "Reviewers",
      icon: <FontAwesomeIcon className="text-2xl" icon={faAddressBook} />,
      link: "/candidate/reviewers",
      slug: "report",
    },
    {
      id: 8,
      title: "Report",
      icon: <FontAwesomeIcon className="text-2xl" icon={faFile} />,
      link: "/candidate/report",
      slug: "report",
    },
  ],
};
